import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetAllUsers } from 'api/users/use-get-all-users';
import { UserRole, useRoleGuard } from 'shared/hooks/use-role-guard';
import { UserCreate } from 'components/users/user-create';
import { UsersList } from 'components/users/users-list';

export const UsersPage = () => {
  const withBlockedParameter = useRoleGuard([UserRole.admin]);
  const { data: users, isLoading, isPreviousData } = useGetAllUsers({ withBlocked: withBlockedParameter });

  const header = <PageHeader extra={<UserCreate />} />;

  return (
    <DefaultPageLayout header={header}>
      {!isLoading || isPreviousData ? <UsersList users={users || []} isLoading={isPreviousData} /> : <Skeleton />}
    </DefaultPageLayout>
  );
};
